module.exports = __webpack_public_path__ + "media/images/linkedin_logo-7fcf44f74a875e93b17870de73746ec3.png";